/**
 * Mapped outlines of the four K&C valley cascade lakes.
 *
 * GENERATED by scripts/import-lakes-kml.mjs. Do not edit by hand.
 *
 * Source: "Map of Lakes in Bengaluru Urban within BBMP Area", ATREE-CSEI, via
 * OpenCity (data.opencity.in), Creative Commons Attribution. Outer rings,
 * simplified at 15 m. Area and centroid are computed from the full ring.
 */
import type { LatLon } from "../types/domain";

export interface LakeOutline {
  /** Lake name exactly as it appears in the source file. */
  readonly sourceName: string;
  readonly areaHa: number;
  readonly centroid: LatLon;
  readonly ring: readonly LatLon[];
}

export const LAKE_OUTLINE_SOURCE = "ATREE-CSEI lake map via OpenCity, CC BY";

export const LAKE_OUTLINES = {
  madiwala: {
    sourceName: "Madivala Kere",
    areaHa: 89.7,
    centroid: { lat: 12.90644, lon: 77.61638 },
    ring: [
      { lat: 12.91316, lon: 77.61625 },
      { lat: 12.91524, lon: 77.61646 },
      { lat: 12.91248, lon: 77.61906 },
      { lat: 12.91231, lon: 77.61976 },
      { lat: 12.91255, lon: 77.62109 },
      { lat: 12.91206, lon: 77.62128 },
      { lat: 12.91103, lon: 77.62119 },
      { lat: 12.90989, lon: 77.62059 },
      { lat: 12.90788, lon: 77.62087 },
      { lat: 12.90569, lon: 77.61906 },
      { lat: 12.90341, lon: 77.61835 },
      { lat: 12.90259, lon: 77.61846 },
      { lat: 12.90274, lon: 77.6177 },
      { lat: 12.90192, lon: 77.61725 },
      { lat: 12.90187, lon: 77.61682 },
      { lat: 12.89937, lon: 77.61403 },
      { lat: 12.89948, lon: 77.61325 },
      { lat: 12.89832, lon: 77.61284 },
      { lat: 12.89814, lon: 77.61227 },
      { lat: 12.89999, lon: 77.61252 },
      { lat: 12.90018, lon: 77.61192 },
      { lat: 12.9021, lon: 77.61193 },
      { lat: 12.90227, lon: 77.61167 },
      { lat: 12.90285, lon: 77.61156 },
      { lat: 12.90301, lon: 77.61111 },
      { lat: 12.90447, lon: 77.61136 },
      { lat: 12.90429, lon: 77.61265 },
      { lat: 12.90606, lon: 77.61336 },
      { lat: 12.90886, lon: 77.61535 },
    ],
  },
  agara: {
    sourceName: "Agara kere",
    areaHa: 29,
    centroid: { lat: 12.92091, lon: 77.6414 },
    ring: [
      { lat: 12.92349, lon: 77.64021 },
      { lat: 12.92313, lon: 77.64132 },
      { lat: 12.92401, lon: 77.64463 },
      { lat: 12.92303, lon: 77.64529 },
      { lat: 12.91759, lon: 77.6406 },
      { lat: 12.91725, lon: 77.64021 },
      { lat: 12.91723, lon: 77.63879 },
      { lat: 12.92078, lon: 77.63882 },
    ],
  },
  bellandur: {
    sourceName: "Bellandur Amanikere",
    areaHa: 328.1,
    centroid: { lat: 12.93476, lon: 77.66365 },
    ring: [
      { lat: 12.92788, lon: 77.65066 },
      { lat: 12.92778, lon: 77.64946 },
      { lat: 12.92729, lon: 77.64825 },
      { lat: 12.92785, lon: 77.64685 },
      { lat: 12.92892, lon: 77.64627 },
      { lat: 12.92962, lon: 77.64487 },
      { lat: 12.92878, lon: 77.64476 },
      { lat: 12.92866, lon: 77.64326 },
      { lat: 12.9289, lon: 77.64297 },
      { lat: 12.92919, lon: 77.64297 },
      { lat: 12.92962, lon: 77.6431 },
      { lat: 12.93115, lon: 77.6444 },
      { lat: 12.93178, lon: 77.64651 },
      { lat: 12.93275, lon: 77.64852 },
      { lat: 12.93365, lon: 77.65312 },
      { lat: 12.93543, lon: 77.6565 },
      { lat: 12.93723, lon: 77.6592 },
      { lat: 12.93815, lon: 77.66014 },
      { lat: 12.93887, lon: 77.66151 },
      { lat: 12.93966, lon: 77.66157 },
      { lat: 12.94012, lon: 77.66085 },
      { lat: 12.94249, lon: 77.66048 },
      { lat: 12.94266, lon: 77.66001 },
      { lat: 12.94412, lon: 77.65991 },
      { lat: 12.9445, lon: 77.66093 },
      { lat: 12.94438, lon: 77.66204 },
      { lat: 12.94409, lon: 77.66193 },
      { lat: 12.94292, lon: 77.66224 },
      { lat: 12.94255, lon: 77.66427 },
      { lat: 12.94186, lon: 77.66553 },
      { lat: 12.94126, lon: 77.66566 },
      { lat: 12.94103, lon: 77.66648 },
      { lat: 12.9396, lon: 77.6686 },
      { lat: 12.93959, lon: 77.66942 },
      { lat: 12.93997, lon: 77.67049 },
      { lat: 12.94223, lon: 77.67334 },
      { lat: 12.94257, lon: 77.67422 },
      { lat: 12.94213, lon: 77.67493 },
      { lat: 12.94146, lon: 77.67491 },
      { lat: 12.94094, lon: 77.67634 },
      { lat: 12.94104, lon: 77.6775 },
      { lat: 12.94319, lon: 77.67949 },
      { lat: 12.94324, lon: 77.6798 },
      { lat: 12.9393, lon: 77.67814 },
      { lat: 12.93811, lon: 77.67728 },
      { lat: 12.9369, lon: 77.67716 },
      { lat: 12.93585, lon: 77.67666 },
      { lat: 12.9336, lon: 77.67698 },
      { lat: 12.93272, lon: 77.67661 },
      { lat: 12.93227, lon: 77.67678 },
      { lat: 12.93183, lon: 77.67653 },
      { lat: 12.93211, lon: 77.67571 },
      { lat: 12.9318, lon: 77.67491 },
      { lat: 12.93139, lon: 77.67452 },
      { lat: 12.93113, lon: 77.67335 },
      { lat: 12.93087, lon: 77.67306 },
      { lat: 12.93079, lon: 77.66899 },
      { lat: 12.93113, lon: 77.66639 },
      { lat: 12.93079, lon: 77.66593 },
      { lat: 12.928, lon: 77.66542 },
      { lat: 12.92799, lon: 77.66373 },
      { lat: 12.92891, lon: 77.66323 },
      { lat: 12.92985, lon: 77.66061 },
      { lat: 12.92943, lon: 77.65696 },
      { lat: 12.92964, lon: 77.65613 },
      { lat: 12.92901, lon: 77.65508 },
      { lat: 12.92933, lon: 77.65364 },
      { lat: 12.92967, lon: 77.65321 },
      { lat: 12.92914, lon: 77.65165 },
      { lat: 12.92785, lon: 77.65101 },
    ],
  },
  varthur: {
    sourceName: "Varthur lake",
    areaHa: 164.3,
    centroid: { lat: 12.94716, lon: 77.73621 },
    ring: [
      { lat: 12.94353, lon: 77.72814 },
      { lat: 12.94321, lon: 77.72719 },
      { lat: 12.94346, lon: 77.72482 },
      { lat: 12.94302, lon: 77.72298 },
      { lat: 12.94317, lon: 77.72256 },
      { lat: 12.94364, lon: 77.72245 },
      { lat: 12.94538, lon: 77.72365 },
      { lat: 12.94633, lon: 77.72492 },
      { lat: 12.94767, lon: 77.72891 },
      { lat: 12.948, lon: 77.73086 },
      { lat: 12.94788, lon: 77.7318 },
      { lat: 12.9482, lon: 77.73276 },
      { lat: 12.94949, lon: 77.73381 },
      { lat: 12.94947, lon: 77.73452 },
      { lat: 12.95068, lon: 77.73667 },
      { lat: 12.95076, lon: 77.73748 },
      { lat: 12.95208, lon: 77.73816 },
      { lat: 12.95203, lon: 77.73877 },
      { lat: 12.95359, lon: 77.74267 },
      { lat: 12.954, lon: 77.74338 },
      { lat: 12.95517, lon: 77.74354 },
      { lat: 12.95605, lon: 77.74413 },
      { lat: 12.95692, lon: 77.74541 },
      { lat: 12.95679, lon: 77.74557 },
      { lat: 12.95624, lon: 77.74478 },
      { lat: 12.95541, lon: 77.74434 },
      { lat: 12.95399, lon: 77.74413 },
      { lat: 12.95349, lon: 77.74437 },
      { lat: 12.9496, lon: 77.74497 },
      { lat: 12.94808, lon: 77.74577 },
      { lat: 12.94652, lon: 77.74627 },
      { lat: 12.94514, lon: 77.74725 },
      { lat: 12.94489, lon: 77.74685 },
      { lat: 12.94568, lon: 77.74557 },
      { lat: 12.9456, lon: 77.74379 },
      { lat: 12.94616, lon: 77.74213 },
      { lat: 12.94494, lon: 77.74098 },
      { lat: 12.94408, lon: 77.73735 },
      { lat: 12.94333, lon: 77.73519 },
      { lat: 12.94268, lon: 77.73475 },
      { lat: 12.94131, lon: 77.73452 },
      { lat: 12.94108, lon: 77.73399 },
      { lat: 12.94136, lon: 77.73249 },
      { lat: 12.94273, lon: 77.73125 },
    ],
  },
} as const satisfies Record<string, LakeOutline>;
